import ImageUploadZone from './ImageUploadZone';

export default ImageUploadZone;
